import { render } from "./UiUx.vue?vue&type=template&id=0352718c&scoped=true"
const script = {}

import "./UiUx.vue?vue&type=style&index=0&id=0352718c&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0352718c"]])

export default __exports__